/**
 * Histopathology Home – Existing Bill.
 * Same layout as New Bill with isExistBilling: shows NXT ID and Biopsy Number in accordion header.
 * Reference: admin4.0 Existing Bill = HistoNewBill with isExistBilling={true}.
 */
import React from "react";
import NewBill from "./NewBill";

export default function ExistingBill() {
  return <NewBill isExistBilling />;
}
